export class Ubicacion {
  id: string;
  codigoPostal: string;
  direccion: string;
  direccionComplemento: string;
}

